import React from "react";

// Components
import RegionsHeader from "./RegionsHeader";
import RegionActionButtons from "./RegionActionButtons";

const taxCountries = Object.keys(EASYCOMMERCE.tax.countries).map((key) => {
    return { value: key, label: EASYCOMMERCE.tax.countries[key] };
});

const Regions = ({
    rates,
    states,
    cities,
    handleAddRegion,
    handleRemoveRegion,
    handleRegionChange,
}) => {
    return (
        <div className="w-full">
            <div className="w-full border border-ec-border p-6 rounded-xl">
                <table className="w-full">
                    <RegionsHeader />

                    <tbody>
                        {rates.map((region, index) => (
                            <tr key={index}>
                                <td className="pb-3">
                                    <select
                                        className="easycommerce-tax-select"
                                        value={region.country}
                                        onChange={(e) =>
                                            handleRegionChange(
                                                index,
                                                "country",
                                                e.target.value
                                            )
                                        }
                                    >
                                        <option value="">- Select -</option>
                                        {taxCountries.map((country) => (
                                            <option value={country.value}>
                                                {country.label}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                                <td className="pb-3">
                                    <select
                                        className="easycommerce-tax-select"
                                        value={region.state}
                                        onChange={(e) =>
                                            handleRegionChange(
                                                index,
                                                "state",
                                                e.target.value
                                            )
                                        }
                                    >
                                        <option value="">- Select -</option>
                                        {states.length > 0 &&
                                            states[index] &&
                                            states[index].length > 0 &&
                                            states[index].map((state, i) => (
                                                <option value={state} key={i}>
                                                    {state}
                                                </option>
                                            ))}
                                    </select>
                                </td>
                                <td className="pb-3">
                                    <select
                                        className="easycommerce-tax-select"
                                        value={region.city}
                                        onChange={(e) =>
                                            handleRegionChange(
                                                index,
                                                "city",
                                                e.target.value
                                            )
                                        }
                                    >
                                        <option value="">- Select -</option>
                                        {cities.length > 0 &&
                                            cities[index] &&
                                            cities[index].length > 0 &&
                                            cities[index].map((city, i) => (
                                                <option value={city} key={i}>
                                                    {city}
                                                </option>
                                            ))}
                                    </select>
                                </td>
                                <td className="pb-3">
                                    <input
                                        type="number"
                                        min={0}
                                        max={100}
                                        step={1}
                                        className="easycommerce-tax-input"
                                        value={region.rate}
                                        onChange={(e) =>
                                            handleRegionChange(
                                                index,
                                                "rate",
                                                e.target.value
                                            )
                                        }
                                    />
                                </td>
                                <RegionActionButtons
                                    add={() => handleAddRegion(index)}
                                    remove={() => handleRemoveRegion(index)}
                                />
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Regions;
